import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.clearDatesModal = new bootstrap.Modal("#clearedDatesModal", { backdrop: "static", keyboard: false });
    this.clearDatesModal.show();
  }
}
